"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bondsQuerySchema = exports.BOND_SOURCES = exports.createSafeTransactionSchema = exports.SAFE_TRANSACTION_KINDS = void 0;
const zod_1 = require("zod");
/** Money entered by the owner as whole IQD; converted to millidinars server-side. */
const iqdAmount = zod_1.z
    .number()
    .int('Amounts are whole dinars — IQD has no useful sub-unit.')
    .min(1, 'A zero movement records nothing.')
    .max(1_000_000_000_000);
/**
 * Wave 3 — the venue's main safe as a real ledger, and the Bonds screen
 * (SPEC §12.1). Every movement of the safe is a numbered voucher ("bond");
 * the Bonds screen additionally lists every money movement in the system,
 * whichever table records it.
 */
/**
 * Every slip kind. The cash drawer (2026-10-12) added four, each written only
 * by the move it records: DRAWER_DROP_IN (drawer cash into the safe — a close,
 * a pickup, or the safe leg of an owner take), DRAWER_TOP_UP (safe cash into
 * the drawer, negative), EXPENSE_PAID (an expense paid from the safe,
 * negative) and INCOME_RECEIVED (an income put into it). BOX_RESET_IN stays
 * for the box resets made before the drawer.
 */
exports.SAFE_TRANSACTION_KINDS = [
    'BOX_RESET_IN',
    'OWNER_WITHDRAWAL',
    'OWNER_DEPOSIT',
    'ADJUSTMENT',
    'DRAWER_DROP_IN',
    'DRAWER_TOP_UP',
    'EXPENSE_PAID',
    'INCOME_RECEIVED',
];
/**
 * What staff may record by hand. Every other kind is deliberately absent:
 * each is written only by the move it records, in the same transaction — a
 * hand-entered "drawer drop" or "reset" would be a slip with no drawer, box or
 * expense behind it.
 */
exports.createSafeTransactionSchema = zod_1.z.object({
    kind: zod_1.z.enum(['OWNER_WITHDRAWAL', 'OWNER_DEPOSIT', 'ADJUSTMENT']),
    /** Always positive on the wire; the server signs it by kind. */
    amountIqd: iqdAmount,
    note: zod_1.z.string().trim().min(1, 'Say what this movement was for.').max(500),
});
/* -------------------------------------------------------------------------- */
/* Bonds — the unified movement ledger                                        */
/* -------------------------------------------------------------------------- */
/** Which table a Bonds row came from — the discriminator staff filter on. */
exports.BOND_SOURCES = [
    'BILL',
    'PAYMENT',
    'BOX_ENTRY',
    'BOX_RESET',
    'REFILL',
    'EXPENSE',
    'INCOME',
    'SAFE',
];
exports.bondsQuerySchema = zod_1.z.object({
    from: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    to: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    /** Omit for everything. */
    sources: zod_1.z.array(zod_1.z.enum(exports.BOND_SOURCES)).optional(),
    employeeId: zod_1.z.string().optional(),
});
//# sourceMappingURL=safe.js.map